var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 43 43",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0.000976562C9.62712 0.000976562 0 9.62621 0 21.5C0 33.3739 9.62618 42.9991 21.5 42.9991C33.3748 42.9991 43 33.3739 43 21.5C43 9.62621 33.3748 0.000976562 21.5 0.000976562ZM21.5 6.42944C25.4287 6.42944 28.6122 9.61393 28.6122 13.5407C28.6122 17.4684 25.4287 20.652 21.5 20.652C17.5732 20.652 14.3897 17.4684 14.3897 13.5407C14.3897 9.61393 17.5732 6.42944 21.5 6.42944ZM21.4953 37.3781C17.577 37.3781 13.9883 35.9511 11.2203 33.5892C10.546 33.014 10.1569 32.1707 10.1569 31.2858C10.1569 27.3033 13.3801 24.116 17.3636 24.116H25.6383C29.6227 24.116 32.8336 27.3033 32.8336 31.2858C32.8336 32.1716 32.4464 33.0131 31.7712 33.5882C29.0041 35.9511 25.4145 37.3781 21.4953 37.3781Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.145d3953.svg";
export { ForwardRef as ReactComponent };